import * as React from "react";
import { matchPath } from "react-router";
import { BreadcrumbGroup, BreadcrumbItem } from "AWS-UI-Components-React";

import { paths } from "../data/constdata.jsx";

const Breadcrumbs = () => {
    const pathname = window.location.pathname;
    const match = matchPath(pathname, {
      path: "/test-cases/:id*"
    });
  
    if (pathname === paths.home || pathname === paths.testCases) {
      return (
        <BreadcrumbGroup>
          <BreadcrumbItem text="Home" href={paths.home}></BreadcrumbItem>
          <BreadcrumbItem text="Create Test Cases" href={paths.testCases}></BreadcrumbItem>
        </BreadcrumbGroup>
      );
    }

    if (pathname === paths.searchTestCases) {
      return (
        <BreadcrumbGroup>
          <BreadcrumbItem text="Home" href={paths.home}></BreadcrumbItem>
          <BreadcrumbItem text="Search Test Cases" href={paths.searchTestCases}></BreadcrumbItem>
        </BreadcrumbGroup>
      );
    }
  
    return (
      <BreadcrumbGroup>
        <BreadcrumbItem text="Home" href={paths.home}></BreadcrumbItem>
        <BreadcrumbItem text="Not Found"></BreadcrumbItem>
      </BreadcrumbGroup>
    );
  };
  
  export default Breadcrumbs;


// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.jsx